import { useState } from 'react'
import { ActionMenu } from '@atrvd/saas-ui'
import { hasPermission } from '@dcp/shared'
import { useProfile } from '@/hooks/useProfile'
import type { FileImportRow } from '@/types/banking'
import { DeleteProjectionImportDialog } from './DeleteProjectionImportDialog'

/**
 * Kebab menu on a Projections Import history row. Offers "Delete Projections"
 * only for a `completed` import and only to roles with `manage_projections` —
 * the RPC enforces both again server-side; this just keeps the action out of
 * reach where it would be refused. Renders nothing otherwise.
 */
export function ProjectionImportRowActions({ fileImport }: { fileImport: FileImportRow }) {
  const { data: profile } = useProfile()
  const [confirming, setConfirming] = useState(false)

  if (fileImport.status !== 'completed') return null
  if (!hasPermission(profile?.productRole, 'manage_projections')) return null

  return (
    <>
      <ActionMenu
        ariaLabel={`Actions for ${fileImport.file_name}`}
        items={[
          {
            id: 'delete',
            label: 'Delete Projections',
            variant: 'danger',
            onClick: () => setConfirming(true),
          },
        ]}
      />
      {confirming && (
        <DeleteProjectionImportDialog fileImport={fileImport} onClose={() => setConfirming(false)} />
      )}
    </>
  )
}
